// Web stub for react-native-switch
import React from 'react';

export const Switch = React.forwardRef<HTMLInputElement>((props: any, ref) => {
  const { value, onValueChange, disabled, style } = props;
  
  const handleChange = (e: any) => {
    if (onValueChange) {
      onValueChange(e.target.checked);
    }
  };

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={value || false}
      onChange={handleChange}
      disabled={disabled || false}
      style={{
        cursor: 'pointer',
        ...style,
      }}
    />
  );
});

Switch.displayName = 'Switch';

export default {
  Switch,
};
